import { StyledOrangeLink } from './styles'

export function OrangeLink({
  children,
  fontSize = 2,
  mobileFontSize = 1,
  fontWeight = 2,
  inherit = false,
  target = '_blank',
  ...linkProps
}) {
  return (
    <StyledOrangeLink
      target={target}
      className="orange-link"
      fontSize={fontSize}
      $mobileFontSize={mobileFontSize}
      fontWeight={fontWeight}
      $inherit={inherit}
      {...linkProps}
    >
      {children}
    </StyledOrangeLink>
  )
}
